module.exports = __webpack_public_path__ + "img/join3-2-h.35bfa501.svg";